import { useRound } from '@/hooks/HostSessionControlHooks';
import AnimatedPrompt from '../Animated/AnimatedPrompt';
import ReactionsBar from '../Controls/ReactionsBar';
import { usePromptTextById } from '@/hooks/usePromptText';
import PlayerCards from './PlayersCards';
import { useEffect, useState } from 'react';

/**
 * PlayersCards component displays a network of player cards with interactive features.
 */
export default function PlayerCardsGame() {
  const round = useRound();
  const promptText = usePromptTextById(round?.promptId);
  const [currentPrompt, setCurrentPrompt] = useState('');

  useEffect(() => {
    if (promptText && promptText !== currentPrompt) {
      setCurrentPrompt(promptText);
    }
  }, [promptText]);

  return (
    <>
      <div className="flex justify-center absolute items-center absolute right-1 top-1 w-[450px] h-[136px] z-10">
        <AnimatedPrompt text={currentPrompt} />
      </div>
      <div className="absolute left-[400px] top-[20px] w-[450px]">
        <ReactionsBar />
      </div>
      <PlayerCards />
    </>
  );
}
